export function enumOptionsToObject<T extends readonly string[]>(options: T) {
  return Object.fromEntries(options.map((o) => [o, o])) as { [key in T[number]]: key }
}
